import { Localization, QueovalBase } from '../global';

// #region DatePicker
export class FormatDate {
  day: string;
  month: string;
}
// #endregion

// #region Select
export class SelectConfig {
  buttonClass: string;
  inputClass: string;
  listClass: string;
}

export class Options {
  value: string;
  text: string;
  selected?: boolean;
}
// #endregion

// #region Alert
export class AlertMessages {
  private listA: Localization[];

  get AlertsList(): Localization[] {
    return this.listA;
  }

  constructor(listAlerts: Localization[]) {
    this.listA = listAlerts;
  }
}
// #endregion


/**
 * Classe générique utilisée principalement pour les Combobox
 */
export class Select {
  public id: string;
  public value: string;

  constructor(id: string = '0', value: string = '-------') {
    this.id = id;
    this.value = value;
  }
}

/**
 * Classe récursive Select contenant elle même une liste à l'intérieur
 */
export class SelectList extends Select {
  public ListSelect: Array<SelectList>;
  public IndexList: number;
}

export class MergeModel extends QueovalBase {
  public PostMode: string;
  public IdDonnee: string;
  public FolderName: string;
  public DataFilter: Map<string, string>;
  public TextGenere: string;
}

/**
 * Combo property
 */
export class ComboProperty {
  public ListProperty: Array<Select>;
  public DefaultProperty: string;
}
